<template>
  <div class="member-detail">
    <div class="banner">
      <img :src="detail.portalTopUrl"  alt="">
    </div>
    <div class="block-wrap">
      <div class="intro">
        <div class="intro-left">
          <div class="intro-left-en">introduction</div>
          <div class="intro-left-cn">会员简介</div>
        </div>
        <div class="intro-right">
          <h4 class="intro-right-title">{{ detail.orgName }}</h4>
          <p class="intro-right-desc">
            {{ detail.memIntroduction }}
          </p>
          <p class="intro-right-split"><span></span><span></span><span></span></p>
          <div class="intro-right-box">
            <div>
              <div class="img-box"></div>
              <!--<div class="item-desc">会员性质</div>-->
            </div>
          </div>
          
        </div>
      </div>
      <SplitLine />
    </div>
    <div class="block-wrap" v-if="detail.memOrgGreatEventList && detail.memOrgGreatEventList.length">
      <div class="story">
        <div class="block-title">
          <h3>大事记</h3>
          <span>Memorabilia</span>
        </div>
        <div class="timeline-box-wrap">
          <div class="timeline-box">
            <div class="story-detail">
              <img src="../../assets/images/member-timeline.png" alt="" class="story-detail-line">
              <div class="story-detail-item"
                    v-for="(item, idx) in detail.memOrgGreatEventList"
                    :key="'detail'+idx"
                    @click="setActiveEvent(item)">
                <span>{{ item.year }}</span>
                <p>{{ item.eventTitle }}</p>
              </div>
            </div>
          </div>
          <div class="timeline-detail-box">
            <img :src="activeEvent.imgSrc" alt="">
            <div class="event-header">
              <h4 :title="activeEvent.eventTitle">{{ activeEvent.eventTitle }}</h4>
              <h5>{{ activeEvent.time }}</h5>
            </div>
            <p :title="activeEvent.eventContent">{{ activeEvent.eventContent }}</p>
          </div>
        </div>
      </div>
      <SplitLine />
    </div>
   <!-- <div class="block-wrap association">
      <div class="block-title">
        <h3>学会风采</h3>
        <span>Association Style</span>
      </div>
      <div class="video-wrap">
        <div class="video-box">
          <video src=""></video>
        </div>
      </div>
      <SplitLine />
    </div>
    -->
    <!-- <div class="block-wrap">
      <div class="organization">
        <div class="block-title">
          <h3>组织架构</h3>
          <span>Organization</span>
        </div>
        <div class="organization-box">
          <div class="organization-item hand"
                v-for="(item, index) in orgList"
                :key="'org'+index"
                :class="activeOrg === item ? 'active' : ''"
                @mouseenter="onActiveOrg(item)">
            <h6>马化腾</h6>
            <div class="organization-item-title">腾讯公司董事会主席</div>
            <div class="organization-item-desc">本会名称为浙江省风景园林学会，英文名为Zhejiang Society of Landscape Architecture，缩写名省科协、浙江省民政厅。</div>
          </div>
        </div>
      </div>
      <SplitLine />
    </div> -->
    <div class="block-wrap" v-if="detail.memOrgWinAwardList && detail.memOrgWinAwardList.length">
      <div class="block-title">
        <h3>荣获奖项</h3>
        <span>Prize</span>
      </div>
      <div class="prize">
        <div class="prize-box">
          <div class="prize-item hand"
                v-for="(item, index) in detail.memOrgWinAwardList"
                :key="'prize'+index"
                :class="activePrize === item ? 'active' : ''"
                @mouseenter="onActivePrize(item)">
            <img :src="item.imgSrc" alt="">
            <h4 :title="item.awardTitle">{{ item.awardTitle }}</h4>
            <p :title="item.awardContent">{{ item.awardContent }}</p>
          </div>
        </div>
      </div>
      <SplitLine />
    </div>
    <div class="block-wrap contact-wrap">
      <div>
        <div class="block-title">
          <h3>联系我们</h3>
          <span>Contact</span>
        </div>
        <div class="contact-box">
          <div class="left-box">
            <h4>{{ detail.orgName }}</h4>
            <p>地址：{{ detail.orgAddress }}</p>
            <p>手机：{{ detail.fixedPhone }}</p>
            <p>邮编：{{ detail.zipCode }}</p>
            <p>传真：{{ detail.fax }}</p>
            <p>电话：{{ detail.fixedPhone }}</p>
            <p>邮箱：{{ detail.mailbox }}</p>
            <p>网址：{{ detail.portalUrl }}</p>
          </div>
          <div class="map-box">
            <Map />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { getMemDetail } from './service/api';
import router from '@/router';
import Map from '@/components/Map.vue';
import defaultBannerAbout from '../../assets/images/banner-about.png';
export default {
  data() {
    return {
      detail: {},
      orgList: [1,2,3,4],
      activeOrg: 1,
      activePrize: 1,
      activeEvent: {}
    }
  },
  components: {
    Map
  },
  mounted() {
    const id = router.currentRoute.query.id;
    if (!id) {
      return router.go(-1);
    }
    getMemDetail({ id }).then(res => {
      if(!res.portalTopUrl){
        res.portalTopUrl = defaultBannerAbout
      }
      res.memOrgGreatEventList = (res.memOrgGreatEventList || []).map(item => {
        item.time = moment(item.eventDate*1000).format('YYYY-MM-DD');
        item.year = new Date(item.eventDate * 1000).getFullYear();
        item.imgSrc = item.attachFileList[0].url;
        return item;
      })
      res.memOrgWinAwardList = (res.memOrgWinAwardList || []).map(item => {
        item.imgSrc = item.attachFileList[0].url;
        return item;
      })
      this.detail = res;
      this.setActiveEvent(res.memOrgGreatEventList[0])
    })
  },
  methods: {
    onActiveOrg(item) {
      this.activeOrg = item;
    },
    onActivePrize(item) {
      this.activePrize = item;
    },
    setActiveEvent(item) {
      item && (this.activeEvent = item);
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/less/global.less';

.banner {
  width: 100%;
  height: 600px;

  > img {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.block-title {
  display: flex;
  align-items: flex-end;

  h3 {
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #131415;
    margin-right: 20px;
  }

  span {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #131415;
    opacity: 0.2;
  }
}

.intro {
  display: flex;

  &-left {
    width: 300px;
    height: 370px;
   	background: url(../../assets/images/train-bg.png) no-repeat center center;
	  background-size: 100% 100%;
    margin-right: 96px;
    padding-top: 230px;
    padding-left: 44px;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: 44px;
      top: 189px;
      width: 54px;
      height: 4px;
      background: #FFFFFF;
    }

    &-en {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #FFFFFF;
      line-height: 24px;
      margin-bottom: 24px;
    }

    &-cn {
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #FFFFFF;
    }
  }

  &-right {
    flex: 1;
    padding-top: 67px;
    display: flex;
    flex-direction: column;

    &-title {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #131415;
      margin-bottom: 29px;
    }

    &-desc {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #131415;
      line-height: 24px;
      margin-bottom: 19px;
    }

    &-split {
      span {
        display: inline-block;
        width: 6px;
        height: 6px;
        background: #06AE63;
        border-radius: 50%;
        margin-right: 8px;
      }
    }

    &-box {
      margin-top: auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      div {
        .img-box {
          width: 76px;
          height: 76px;
          background: #FFFFFF;
          border: 1px solid #06AE63;
          border-radius: 50%;
          margin-bottom: 9px;
          background: url(../../assets/images/member-diamond.png) no-repeat center center;
	        background-size: 36px 33px;
        }

        .item-desc {
          height: 14px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #131415;
          line-height: 24px;
        }
      }
    }
  }
}

.story {

  .timeline-box-wrap {
    height: 400px;
    width: 100%;
    display: flex;
    margin-top: 29px;

    .timeline-box {
      flex: 1;
      height: 100%;
      overflow: hidden;
      overflow-x: auto;
    }

    .timeline-detail-box {
      width: 400px;
      margin-left: 2px;
      background: #06AE63;
      padding-left: 20px;
      margin-top: 20px;

      img {
        margin-top: -20px;
        width: 100%;
        height: 340px;
      }

      .event-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 20px;
        margin-bottom: 4px;

        h4 {
          font-size: 24px;
          color: #FFFFFF;
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        h5 {
          font-size: 14px;
          color: #FFFFFF;
          margin-left: 20px;
        }
      }

      p {
        font-size: 14px;
        color: #FFFFFF;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }

  &-detail {
    width: 1099px;
    height: 100%;
    position: relative;
    background: url(../../assets/images/member-ditu.png) no-repeat center center;
	  background-size: 1099px 548px;

    &-line {
      user-select: none;
      -webkit-user-drag: none; 
      width: 100%;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }

    &-item {
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 15px 0;
      cursor: pointer;

      &::before {
        content: '';
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 10px;
        height: 10px;
        background: #F1F3F3;
        border-radius: 50%;
      }
      
      span {
        font-size: 14px;
        font-family: DIN Alternate;
        font-weight: bold;
        color: #787878;
        line-height: 24px;
        margin-bottom: 9px;
      }

      p {
        width: 14px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #787878;
        line-height: 16px;
        word-break: break-all;
      }

      &:nth-child(2) {
        left: 48px;
        top: 281px;

        &::before {
          top: 0;
        }
      }

      &:nth-child(3) {
        left: 100px;
        bottom: 96px;

        &::before {
          bottom: 0;
        }
      }

      &:nth-child(4) {
        left: 139px;
        top: 283px;

        &::before {
          top: 0;
        }
      }

      &:nth-child(5) {
        left: 214px;
        bottom: 147px;

        &::before {
          bottom: 0;
        }
      }

      &:nth-child(6) {
        left: 255px;
        bottom: 175px;

        &::before {
          bottom: 0;
        }
      }

      &:nth-child(7) {
        left: 328px;
        top: 200px;

        &::before {
          top: 0;
        }
      }

      &:nth-child(8) {
        left: 373px;
        top: 209px;

        &::before {
          top: 0;
        }
      }

      &:nth-child(9) {
        left: 438px;
        top: 224px;

        &::before {
          top: 0;
        }
      }

      &:nth-child(10) {
        left: 490px;
        bottom: 161px;

        &::before {
          bottom: 0;
        }
      }

      &:nth-child(11) {
        left: 540px;
        top: 204px;

        &::before {
          top: 0;
        }
      }

      &:nth-child(12) {
        left: 588px;
        top: 168px;

        &::before {
          top: 0;
        }
      }

      &:nth-child(13) {
        left: 633px;
        top: 128px;

        &::before {
          top: 0;
        }
      }

      &:nth-child(14) {
        left: 690px;
        bottom: 282px;

        &::before {
          bottom: 0;
        }
      }

      &:nth-child(15) {
        left: 750px;
        bottom: 270px;

        &::before {
          bottom: 0;
        }
      }

      &:nth-child(16) {
        left: 810px;
        bottom: 237px;

        &::before {
          bottom: 0;
        }
      }

      &:nth-child(17) {
        left: 860px;
        top: 165px;

        &::before {
          top: 0;
        }
      }

      &:nth-child(18) {
        left: 910px;
        bottom: 220px;

        &::before {
          bottom: 0;
        }
      }

      &:nth-child(19) {
        left: 960px;
        bottom: 232px;

        &::before {
          bottom: 0;
        }
      }

      &:nth-child(20) {
        left: 1000px;
        bottom: 249px;

        &::before {
          bottom: 0;
        }
      }

      &:nth-child(21) {
        left: 1049px;
        top: 108px;

        &::before {
          top: 0;
        }
      }
    }
  }
}

.association {

  .block-title {
    margin-bottom: 31px;
  }

  .video-wrap {
    width: 100%;
    background: url(../../assets/images/member-association-bg.png) no-repeat center center;
	  background-size: 100% 532px;
  
    .video-box {
      width: @middleWidth;
      margin: 0 auto;
      height: 720px;
      padding: 10px;
      background: #FFFFFF;

      video {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
}

.organization {
  .block-title {
    margin-bottom: 40px;
  }

  &-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .organization-item {
      width: 590px;
      height: 165px;
      background: #F5F7F7;
      border: 4px solid transparent;
      margin-bottom: 50px;
      padding: 34px 69px 0 34px;

      &.active {
        border-color: #06AE63;
      }
      
      h6 {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #131415;
        margin-bottom: 12px;
      }

      &-title {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #06AE63;
        margin-bottom: 21px;
      }

      &-desc {
        &:extend(.line2);
        font-size: 14px;
        font-family: PingFang SC;
        color: #131415;
        line-height: 24px;
      }
    }
  }
}

.prize {
  width: 100% !important;
  height: 510px;
  background: url(../../assets/images/member-prize-bg.png) no-repeat center center;
  background-size: 100% 100%;
  padding-top: 29px;

  &-box {
    width: @middleWidth;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .prize-item {
      width: 286px;
      background: #F5F7F7;
      border: 8px solid transparent;
      padding: 28px 30px;
      display: flex;
      flex-direction: column;
      align-items: center;

      &.active {
        border-color: #06AE63;
      }

      img {
        width: 100%;
        height: 310px;
        margin-bottom: 25px;
      }

      h4 {
        &:extend(.line1);
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #131415;
        line-height: 24px;
        margin-bottom: 11px;
      }

      p {
        &:extend(.line1);
        height: 14px;
        margin-top: auto;
        font-size: 14px;
        font-family: PingFang SC;
        color: #787878;
      }
    }
  }
}

.contact-wrap {
  padding-bottom: 97px;
  
  .block-title {
    margin-bottom: 33px;
  }

  .contact-box {
    position: relative;
    .left-box {
      width: 546px;
      height: 481px;
      background: url(../../assets/images/train-bg.png) no-repeat center center;
      background-size: 100% 100%;
      padding-left: 31px;
      padding-top: 110px;

      h4 {
        position: relative;
        height: 25px;
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #FFFFFF;
        margin-bottom: 72px;

        &::after {
          content: '';
          width: 54px;
          height: 4px;
          background: #FFFFFF;
          position: absolute;
          left: 0;
          bottom: -29px;
        }
      }

      p {
        height: 16px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 24px;
        margin-bottom: 20px;
      }
    }

    .map-box {
      width: 827px;
      height: 440px;
      position: absolute;
      right: 0;
      top: 21px;
      padding: 10px;
      background: #FFFFFF;

      .map {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>